import Vue from 'vue';

/**
 * Class Fornecedor Service
 */
export default class ReportService extends Vue {

    private customActions = {
        uploadReport: {method: 'POST', url: 'auth/upload_report'},
        getCostValue: { method: 'GET', url: 'integration/app/get-subaccount-spending{/firstDate}{/lastDate}{/platformId}'},
    };
    private resource: any = this.$resource('auth/upload_report', {}, this.customActions);

    public saveFile($file) {
        let data = new FormData();
        data.append('file', $file);
        this.$http.post('https://cleversale.s3.amazonaws.com', data);
    }

    // GET platform report auth
    public getReportAuth() {
        return this.resource.uploadReport().then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public async getCostValue(firstDate: string, lastDate: string, platformId?: number) {
        return await this.resource.getCostValue({ firstDate, lastDate, platformId}).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

}
